export default __webpack_public_path__ + "static/media/menu-logs.2e0b2972.png";